function generateSrcset(imageObject, widths = []) {
    const imageUrl = new URL(imageObject['src']);
    return widths
        .filter((width) => width <= imageObject['width'])
        .map((width) => {
            imageUrl.searchParams.set('width', width.toString());
            return `${imageUrl.href} ${width}w`;
        })
        .join(', ');
}

function createMediaImg(media, widths = [], properties = {}) {
    if (!media) return;
    const image = new Image(
        media['preview_image']['width'],
        media['preview_image']['height']
    );
    const featuredMediaUrl = media['preview_image']['src'];
    for (const propertyKey in properties) {
        image.setAttribute(propertyKey, properties[propertyKey]);
    }
    image.alt = media['alt'];
    image.src = featuredMediaUrl;
    // image.srcset = generateSrcset(media['preview_image'], widths);
    return image;
}

var VariantMedia = class extends HTMLElement {
    constructor() {
        super();
        this._onVariantChangedListener = this._onVariantChanged.bind(this);
    }

    connectedCallback() {
        this.sizesAttribute = this.querySelector('img').sizes;
        this.classAttribute = this.querySelector('img').className;
        document.forms[this.getAttribute('form')]?.addEventListener(
            'variant:change',
            this._onVariantChangedListener
        );
    }

    disconnectedCallback() {
        document.forms[this.getAttribute('form')]?.removeEventListener(
            'variant:change',
            this._onVariantChangedListener
        );
    }

    get widths() {
        return this.getAttribute('widths')
            .split(',')
            .map((width) => parseInt(width));
    }

    _onVariantChanged(event) {
        if (!event.detail.variant || !event.detail.variant['featured_media']) {
            return;
        }

        this.replaceChildren(
            createMediaImg(
                event.detail.variant['featured_media'],
                this.widths,
                {
                    class: this.classAttribute,
                    sizes: this.sizesAttribute,
                }
            )
        );
    }
};

if (!window.customElements.get('variant-media')) {
    window.customElements.define('variant-media', VariantMedia);
}
